import Paragraph from 'src/components/layout/Paragraph'
import { WalletContainer } from './style'
import ConnectDetails from 'src/walliro/containers/AppLayout/Header/ProviderDetails/ConnectDetails'
import WalletSwitch from 'src/components/WalletSwitch'
import Block from 'src/components/layout/Block'
import { wrapInSuspense } from 'src/utils/wrapInSuspense'
import HidePairingModule from 'src/walliro/containers/AppLayout/Header/ProviderDetails/HidePairingModule'
import { isPairingSupported } from 'src/logic/wallets/pairing/utils'

interface Props {
  isWalletConnected: boolean
  isWrongNetwork: boolean
}
const StepTwo = ({ isWalletConnected, isWrongNetwork }: Props) => {
  return (
    <Block className="px-lg-5 py-lg-4 p-3">
      {isWalletConnected ? (
        <>
          {!isWrongNetwork && (
            <Paragraph color="primary" noMargin size="lg">
              Wallet connected.
            </Paragraph>
          )}
        </>
      ) : (
        <Paragraph color="primary" noMargin size="lg">
          In order to create your Walliro, you need to connect a wallet
        </Paragraph>
      )}
      {isPairingSupported() && wrapInSuspense(<HidePairingModule />)}
      {!isWalletConnected && (
        <WalletContainer>
          <ConnectDetails />
        </WalletContainer>
      )}

      {isWalletConnected && isWrongNetwork && (
        <Paragraph color="primary" size="lg">
          Your wallet connection must match the selected network. <WalletSwitch />
        </Paragraph>
      )}
    </Block>
  )
}

export default StepTwo
